module.exports = __webpack_public_path__ + "img/return.23498bf6.png";